export default {
  title:'撲通撲通妮姬投票 人氣Top1時裝投票',
  time:'2023/06/29 12:00-2023/07/05 23:59 (UTC+9)',
  curp:'當前人氣值',
  bottips:'累計人氣值將在每日18:00(UTC+9)刷新。',
  toptips:'時裝方案圖片僅為開發中的概念原稿，不代表最終時裝的外形與動作。',
  dvotet:'請確認你的投票選項。',
  dvotep:'點擊確認後，將不可更改選擇。',
  cancel:'取消',
  confirm:'確認',
  dloginp:'首次登錄並完成時裝方案投票，<br><strong>會獲得1張招募券</strong>。',
  username:'信箱',
  password:'密碼',
  login:'登錄',
  register:'下載及註冊',
  logintips:'請在遊戲中注册帳戶',
  forgetPassword:'忘記密碼',
  logint:'確認您的角色名稱',
  server:'伺服器',
  nickname:'角色昵稱',
  logintip2:'*每個帳號只能綁定一個角色投票及獲得獎勵',
  rulet:'規則',
  rp1:'活動簡介<br>活動日期：2023/06/29 12:00 (UTC+9)至2023/07/05 23:59 (UTC+9)<br>活動期間，玩家可為最心儀的神罰時裝方案進行投票。在活動結束後得票數第一的方案會正式進行制作，並在後續免費贈送給全部玩家！<br>* 贈送日期請等待後續官方通知。',
  rp2:'活動參加說明<br>活動期間，玩家可為心意的時裝方案進行1次投票，完成投票後將無法變更。',
  rp3:'遊戲獎勵<br>1.完成時裝方案的投票後，即可領取招募券1張，每人僅限領取1次，您可以在遊戲內郵箱中確認獎勵。<br>2.第一次完成指定的社群分享，即可領取招募券1張，每人僅限領取1次，您可以在遊戲內郵箱中確認獎勵。',
  rp4:'注意事項<br>1.時裝方案圖片僅為開發中的概念原稿，不代表最終時裝的外形與動作。<br>2.請各位玩家登錄遊戲帳戶並參與活動，每個帳戶只能綁定一個服務器及角色名稱，保證活動獎勵能正常發放及領取。<br>3.頁面上NIKKE的人氣值數據更新時間為每天18:00（UTC+9）。最終投票結果將於7月6日18點(UTC+9)在此頁面公布。<br>4.完成活動所獲得的遊戲內獎勵會自動發放至郵箱，獎勵發放可能會因系統原因有一定時間上的延遲，郵件有效期為30天，請注意查收。',
  rp5:'最終投票結果將於7月6日18點(UTC+9)在此頁面公布。',
  votebtn:'投票',
  surepara:'參與即同意 <a href="https://hotcool.com.tw/privacy_policy" class="dicon5" title="">隱私政策</a> 使用及接收獎勵資訊。官方保留以上活動及獎項內容修改之權利，並有權決定修改、取消、暫停或終止活動及贈送內容，變更內容將於官方網站或官方粉絲團公告，恕不另行通知。',
  plan1:'-方案A-',
  plan2:'-方案B-',
  plan3:'-方案C-',

  third_auth_failed: '第三方登入失敗。請重試！',
  account_not_exist: '帳號不存在。 請在遊戲中註冊一個帳號。',
  password_empty: '沒有輸入密碼',
  pleaseLogIn: '請先登入',
  password_not_set: '未設定帳號密碼',
  shareContent: `指揮官年度作戰報告已產生！ 快來回顧你與妮姬的一週年～

  #妮姬年度作戰報告 #妮姬一週年 #妮姬勝利集結紀念日
  指揮官個人年度作戰報告待查收！
  領取你的一週年紀念獎勵！
  `,

  BaseSystemError: '投票系統錯誤',
  VoteDelNumNotEnough: '投票機會不足',
  RoleInfoNotSaved: '角色資料未儲存',
  NoRoleInfo: '沒有查到角色資料',
  RoleInfoHasSaved: '角色資料已儲存',
  FlowHasNotBegin: '活動時間未開始',
  FlowHasEnd: '活動已結束',
  MiddlewareFlowLock: '刷新太快，請稍後重試',
  SignedDayNotEnough: '今日解鎖次數已達上限，請明天再試',
  HasSignedToday: '今日已簽到',
  GetGiftLimit: '已達到禮包領取限制',
  pls_input_info: '請輸入您的登入資訊。',
  serverError: '伺服器錯誤',
  networkError: '網路錯誤',
  GetRoleInfoAccountTypeErr: '帳號類型錯誤',
  please_select: '請選擇',
  submitted_vote: '您已投票，無法再次投票。',
  share_failed: '分享失敗',
  open_in_browser: '請在其他瀏覽器中打開。',
  no_role_found: '找不到角色',
  laodingPic: '正在生成圖像…',
  loading: '載入中....',
  nv_vote_p: '人氣最高選項將做成免費服裝發放！',
  open_in_browser: '請嘗試使用其他瀏覽器開啟',
  logout: '登出',
  privacy:'隱私權政策',
  cookies:'Cookie 政策',
  privacyLink:'https://hotcool.com.tw/privacy_policy',
  cookiesLink:'https://nikke.hotcool.tw/cookie_policy.html',

  claimable: '可領取',
  claimed: '已領取',
  claimSucess: '領取成功',

  elysion: '極樂淨土',
  pilgrim: '朝聖者',
  tetra: '泰特拉',
  missilis: '米西利斯',
};
